import { useEffect, useRef, createRef } from "react";
import gsap, { Power2 } from "gsap";
import { ScrollTrigger, CSSRulePlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, CSSRulePlugin);

export const useVideoAnimation = () => {
  const containerRefs = useRef([]);
  const imageRefs = useRef([]);

const instanceCount = 16;
containerRefs.current = Array(instanceCount).fill().map((_, i) => containerRefs.current[i] || createRef());
imageRefs.current = Array(instanceCount).fill().map((_, i) => imageRefs.current[i] || createRef());

useEffect(() => {
  const animateContent = (container, content) => {

    const contentElement = content.ref.current;
    const revealElement = CSSRulePlugin.getRule(".img-container:after");

    const fxtimeline = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: "top 80%",
        end: "bottom 0%",
        onEnter: () => gsap.set(container.current, { visibility: "visible" }),
        toggleActions: "play none none none",
        markers: false,
      }
    });

    fxtimeline
      .to(revealElement, { duration: 2, width: "0%", ease: Power2.easeOut })
      .from(contentElement, { duration: 2, scale: 0.8, ease: Power2.easeOut, clearProps: "all", delay: -2 });

    return fxtimeline;
  };

  const timer = setTimeout(() => {
    containerRefs.current.forEach((containerRef, index) => {
      const content = imageRefs.current[index]; 
      animateContent(containerRef, { ref: content });
    });
  }, 100);

  return () => {
    clearTimeout(timer);
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  };
}, []);

  return { containerRefs, imageRefs };
};
